/** @format */

import { useCallback, useEffect, useState, useRef } from 'react';
import { useNavbar, useSystem } from '../../../modules/navbar';
import { getLocalStorageLng, getLocalStorageToken } from 'utils/utils';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import useRWD from '../../../hooks/useRwd';
import { useHistory } from 'react-router-dom';
import { useModal } from '../../../modules/ui';
import { registrationStatus } from '../../../modules/navbar/types';

export const useUserGroup = () => {
	const { RWD, size, MD } = useRWD();
	const showAvatar = size > MD;
	const token = getLocalStorageToken();
	const localizedLang = getLocalStorageLng();
	const history = useHistory();
	const {
		aud,
		status,
		avatars,
		boundGetToken,
		boundRemoveToken,
		boundCheckCreateMeetupStatus,
		boundResetCreateMeetupStatus,
		boundFetchUserData,
		boundClearUserData
	} = useNavbar();
	const { pending } = useSystem();
	const [isOpen, setIsOpen] = useState(false);
	const { boundToggleRightSidebar, boundToggleExtraMeetupModal } = useModal();

	const ref = useRef();
	useOnClickOutside(ref, () => setIsOpen(false));

	useEffect(() => {
		if (token) {
			boundGetToken();
		} else {
			// need to reset createStatus
			boundRemoveToken();
			boundClearUserData();
		}
	}, [token]);

	useEffect(() => {
		switch (status.registerStatus) {
			case registrationStatus.NEW_USER: {
				boundToggleRightSidebar(false);
				history.push(`/${localizedLang}/signup`);
				boundResetCreateMeetupStatus();
				return;
			}
			case registrationStatus.UNFINISH: {
				boundResetCreateMeetupStatus();
				boundToggleRightSidebar(false);
				history.push({
					pathname: `/${localizedLang}/signup`,
					state: { signupOrder: 2 }
				});
				return;
			}
		}

		switch (status.createMeetupStatus) {
			case 'success': {
				boundResetCreateMeetupStatus();
				boundToggleRightSidebar(false);
				history.push(`/${localizedLang}/meetup/create`);
				break;
			}
			case 'extra': {
				boundResetCreateMeetupStatus();
				boundToggleRightSidebar(false);
				boundToggleExtraMeetupModal();
				break;
			}
		}
	}, [status]);

	useEffect(() => {
		if (aud) {
			boundFetchUserData();
		}
	}, [aud]);

	const handleCreateMeetup = useCallback(() => {
		boundCheckCreateMeetupStatus();
	}, [boundCheckCreateMeetupStatus]);

	const toggleModal = useCallback(() => {
		setIsOpen(!isOpen);
	}, [setIsOpen, isOpen]);

	return {
		RWD,
		showAvatar,
		aud,
		ref,
		avatars,
		isOpen,
		createStatus: status.createStatus,
		pending,
		toggleModal,
		handleCreateMeetup
	};
};
